<template>
  <div v-if="status === true">
    <van-row>
      <van-col span="21">
        <div style="">
          <van-tabs v-model="active_model" @click="onSelect" v-if="status===true"
                    swipeable
                    :border="false"
                    :color="$common.transparent ? JdSelectListSheet_parent.font_color : '#EE0A24'"
                    :title-active-color="$common.transparent ? JdSelectListSheet_parent.font_color : '#EE0A24'"
                    :title-inactive-color="$common.transparent ? 'rgba(255,255,255, 0.7)' : ''"
                    :background="$common.transparent ? 'rgba(255,255,255,0)' : '#FFFFFF'"
          >

            <van-tab v-for="(item,index) in category_list" :key="index"
                     :title="item.name"
                     :name="item.id"
            >
              <div slot="title" style="font-size: 16px">{{ item.name }}</div>
              <!--                            <div slot="title" :style="{fontSize: active_model === item.id ? '17px' : '15px'}">-->
              <!--                                {{item.name}}-->
              <!--                            </div>-->
            </van-tab>
          </van-tabs>
          <div v-if="showCategoryTabs_home_float_div"
               style="position: absolute; top: 50px; height: 46px; line-height: 46px; padding: 1px 26px; font-size: 16px;
                            background-color: #ffffff; color: #818283; box-shadow:4px 0 5px -5px #999;"
               @click="clickHomeFloatDiv">
            推荐
          </div>
        </div>
      </van-col>
      <van-col span="3" style="">
        <div style="padding-left: 3px; height: 100%; width: 100%; ">
          <div style="text-align: center; margin-top: 1px; margin-right: 5px; box-shadow: -3px 0 5px -5px #555;">
            <van-icon name="bars" size="30" style="padding-top: 6px"
                      :color="$common.transparent ? JdSelectListSheet_parent.font_color : '#EE0A24'"
                      @click="showTopPop"/>
          </div>
        </div>

      </van-col>
    </van-row>

    <!--        <van-divider style="margin-top: 0px; margin-bottom: 0px; border-color: #dddddd"/>-->

    <van-popup
        v-model="showPop"
        position="top"
    >
      <div>
        <div style="text-align: center; padding: 10px 0px">
          <span style="font-size: 16px">全部分类</span>
          <van-icon name="close" size="22" color="#EE0A24" @click="clickCloseIcon"
                    style="position: absolute; right: 15px; margin-top: 2px"
          />
        </div>
        <van-divider style="margin-top: 0px; margin-bottom: 0px; border-color: #dddddd"/>
        <div style="text-align: center">
          <van-grid :column-num="columnNum" :border="false" style="padding: 10px 10px">
            <van-grid-item
                v-for="(tag, index) in category_list"
                :key="index"
            >
              <van-tag :plain="!isTagClicked(index)" :type="isTagClicked(index)? 'danger' : 'primary'" size="medium"
                       @click="clickTag(index)">
                <div slot="default" style="width: 60px">
                  {{ tag.name }}
                </div>
              </van-tag>
            </van-grid-item>
          </van-grid>
        </div>

      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'JdCategoryTabs',
  components: {},
  props: {
    // active:{type: String, default: "0"}
    showTabsHome: { type: Boolean, defalut: true }
  },

  inject: ['JdSelectListSheet_parent'],

  data () {
    return {
      status: false,
      category_list: [
        {
          grade: '-2',
          id: '-2',
          img: 'http://api.wapg.cn/jd_union/images/group/01.png',
          name: '推荐',
          parentId: '-2',
        },
        {
          grade: '-1',
          id: '-1',
          img: 'http://api.wapg.cn/jd_union/images/group/01.png',
          name: '全部',
          parentId: '0',
        }
      ],
      active_model: this.active,

      showPop: false,

      // // 屏幕宽
      screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      //
      // tag_width: ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) / 5),

      columnNum: 4,

      tag_type: 'primary',

      clicked_tag_index: 0,

      clicked_tag_index_temp: -1,
      //是否显示类别tab嘴边悬浮的"推荐div"（仅在类别tab的list的index>=3时才显示）
      showCategoryTabs_home_float_div: false,
    }
  },
  watch: {
    showTabsHome (newValue) {
      if (!newValue) {
        this.category_list.splice(0, 1)
        this.showCategoryTabs_home_float_div = false
      }
    }
  },
  created () {
    this.getCategoryList()
    if (this.screenWidth >= 400) {
      this.columnNum = 4
    } else {
      this.columnNum = 3
    }

    if (!this.showTabsHome) {
      this.category_list.splice(0, 1)
      this.showCategoryTabs_home_float_div = false
    }
  },
  methods: {

    clickHomeFloatDiv () {
      this.showCategoryTabs_home_float_div = false
      this.active_model = '-2'
      this.onSelect('-2')
    },

    /**
     * 顶部弹出的类别选择弹窗中，tag被点击选中
     * @param index
     * @return {boolean}
     */
    isTagClicked (index) {
      if ((this.clicked_tag_index !== -1 && this.clicked_tag_index === index)) {

        return true
      } else {
        return false
      }
    },

    clickTag (index) {
      this.clicked_tag_index = index
      if (this.category_list) {
        let tag_item = this.category_list[index]
        this.onSelect(tag_item.id)
        this.active_model = tag_item.id
        // this.tag_type = "danger";
      }

      this.clickCloseIcon()
    },

    clickCloseIcon () {
      this.showPop = false
    },

    showTopPop () {
      this.showPop = true
    },

    getCategoryList () {
      let that = this
      this.$getCategoryList(function (response) {

        that.category_list.push.apply(that.category_list, response.data)
        that.status = true

        // if(!that.showTabsHome){
        //     that.category_list.splice(0, 1);
        //     that.showCategoryTabs_home_float_div = false;
        // }

        that.$emit('loadFinish', true)

      })
    },
    onSelect (tabID) {
      let selectIndex = -1
      let selectData = null
      // for (let i in this.category_list) {
      //     let item = this.category_list[i];
      //     if (item.id === tabID) {
      //         selectIndex = i;
      //         selectData = item;
      //         break;
      //     }
      // }

      for (let i = 0; i < this.category_list.length; i++) {
        let item = this.category_list[i]

        if (item.id === tabID) {
          selectIndex = i
          selectData = item
          break
        }
      }
      if (selectIndex === -1) {
        this.clicked_tag_index = 0
      }
      if (selectData) {
        //此处判断是将clicked_tag_index作为一个临时缓存，如果不相同，则触发回调，相同，则不触发，以避免点击相同标签时，每次都加载
        if (this.clicked_tag_index_temp !== selectIndex) {
          this.$emit('onSelect', selectData)
          if (selectIndex !== -1) {
            //将顶部弹窗的tag设置为相对应的选项
            this.clicked_tag_index = selectIndex
            this.clicked_tag_index_temp = selectIndex
          }
        }
      }

      if (selectIndex >= 3 && this.showTabsHome && !this.JdSelectListSheet_parent.showHome) {
        this.showCategoryTabs_home_float_div = true
      } else {
        this.showCategoryTabs_home_float_div = false
      }

    }
  },
  // watch:{
  //     active(newValue){
  //         if(newValue === "0"){
  //             this.active_model = newValue;
  //         }
  //     }
  // }
}
</script>

<style scoped>

/deep/ .van-grid-item .van-grid-item__content {
  /*background-color: rgba(255, 255, 255, 0);*/
  padding: 15px 0px;
}

</style>